<div class="company-detail">
  <div class="button-area">
    <div class="button-area__right">
      <button *ngIf="!auth.isYakuin" class="detail-action-btn detail-action-btn--save" (click)="editCompanyData()">Edit</button>
    </div>
  </div>

  <div class="section-card">
    <div class="section-title">{{ 'companyInformation' | translate }}</div>
    <div class="detail-grid">
      <div class="detail-item">
        <div class="detail-label">{{ 'companyName' | translate }}</div>
        <div class="details">{{ companyData.name || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'japaneseCompanyOtherName' | translate }}</div>
        <div class="details">{{ companyData.otherName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'ceo' | translate }}</div>
        <div class="details">{{ companyData.ceo || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'email' | translate }}</div>
        <div class="details">{{ companyData.email || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'phone' | translate }}</div>
        <div class="details">{{ companyData.telephone || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'fax' | translate }}</div>
        <div class="details">{{ companyData.fax || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'address' | translate }}</div>
        <div class="details">{{ companyData.address || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'city' | translate }}</div>
        <div class="details">{{ companyData.city || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'zipCode' | translate }}</div>
        <div class="details">{{ companyData.zipCode || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'country' | translate }}</div>
        <div class="details">{{ companyData.country || '-' }}</div>
      </div>
    </div>
  </div>
</div>